import React, { Component } from 'react'
import { MuiGrid, MuiTypography, MuiInputBase, MuiTextField, MuiButton, MuiToolTip } from '../../../../../ui/MaterialUIComponents'
import { Typography, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core'
import lodashUtil from 'lodash';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import * as StringReplacer from '../../../../../../i18n/StringReplacer'
import { DialogComponentUtil } from '..';
import theme from '../../../../../../assests/theme'
import spinner from "../../../../../ui/icons/spinner.gif";

export class ElectiveTeachersAndTAsComponent extends Component {
	render() {
		const { i18n } = this.props
		return (
			<React.Fragment>
				{this.props.elective.subjects.map((subject, index) =>
					<ExpansionPanel >
						<ExpansionPanelSummary
							onClick={() => this.props.getNumberOfTeachersAndTAs(subject, index)}
							expandIcon={<ExpandMoreIcon />}
							aria-controls="panel1a-content"
							id="panel1a-header"
						>
							<MuiGrid container>
								<MuiToolTip
									placement="top-start"
									title={StringReplacer.getFormatedMessage(i18n.teachersAndTAs.heading,
										{
											Elective: DialogComponentUtil.getSubjectsForTemplate(this.props),
											Subject: subject.name,
											Grades: DialogComponentUtil.getToolTipString(this.props),
										})
									} >
									<MuiTypography style={theme.typography.h6} gutterBottom>
										{StringReplacer.getFormatedMessage(i18n.teachersAndTAs.heading,
											{
												Elective: DialogComponentUtil.getSubjectsForTemplate(this.props),
												Subject: subject.name,
												Grades: DialogComponentUtil.getGradeForTemplate(this.props),
											})
										}
									</MuiTypography>
								</MuiToolTip>
							</MuiGrid>
						</ExpansionPanelSummary>
						{/* Box 1 */}
						<ExpansionPanelDetails >
							<MuiGrid item xs container style={{ marginRight: "5px" }}>
								<MuiGrid container justify="center" alignItems="center" style={theme.tableHeaderStyle}>
									<MuiTypography style={theme.tableHeaderTextStyle}>
										{i18n.teachersAndTAs.numberOfTeachers}
									</MuiTypography>
								</MuiGrid>

								<MuiGrid container justify="center" style={theme.gridTableSelectStyle}>
									<MuiTextField
										style={{ width: "80%" }}
										// type="number" 
										variant="standard"
										select
										autoComplete
										value={this.props.numberOfTeachersAndTAsForElective.teachersAndTAs[index].teachers}
										onChange={(event) => { this.props.handleChangeForElective(event.target.value, "teachers", index) }}
										SelectProps={{ native: true, disableUnderline: 'true' }}>
										<option style={{ display: 'none' }}>
										</option>
										{lodashUtil.times(this.props.totalTeachers[index] + 1).map((i) => <option

											value={i}>{i}</option>)}
									</MuiTextField>

								</MuiGrid>
							</MuiGrid>

							{/* Box 2  */}
							<MuiGrid item xs container style={{ marginLeft: "5px" }}>
								<MuiGrid container justify="center" alignItems="center" style={theme.tableHeaderStyle}>
									<MuiTypography style={theme.tableHeaderTextStyle}>
										{i18n.teachersAndTAs.numberOfTAs}
									</MuiTypography>
								</MuiGrid>
								<MuiGrid container justify="center" style={theme.gridTableSelectStyle}>
									<MuiTextField
										style={{ width: "80%" }}
										// type="number" 
										variant="standard"
										select
										autoComplete
										value={this.props.numberOfTeachersAndTAsForElective.teachersAndTAs[index].TAs}
										onChange={(event) => { this.props.handleChangeForElective(event.target.value, "TAs", index) }}
										SelectProps={{ native: true, disableUnderline: 'true' }}>>
										<option style={{ display: 'none' }}>
										</option>
										{lodashUtil.times(this.props.totalTAs[index] + 1).map((i) => <option
											value={i}>{i}</option>)}
									</MuiTextField>
								</MuiGrid>
							</MuiGrid>
						</ExpansionPanelDetails>
					</ExpansionPanel>)}
				{/* buttons  */}
				<MuiGrid container justify="flex-end" style={{ marginTop: "10px", paddingTop: "10px", borderTop: "1px solid " + theme.palette.grey.main }}>
					<MuiGrid item style={{ marginRight: "10px" }}>
						<MuiButton style={theme.secondaryButtonStyle} onClick={() => { this.props.handleCloseForDialog() }}>
							{i18n.commonTexts.cancel}
						</MuiButton>
					</MuiGrid>

					<MuiGrid item>
						{this.props.updateSchoolinformationInProgress ? <img src={spinner} alt="none" style={theme.spinnerImgStyleForButton} /> :
							<MuiButton disabled={this.props.disableEdit} style={this.props.disableEdit ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle} onClick={() => { this.props.onClickOfSave() }}>
								{i18n.commonTexts.apply}
							</MuiButton>}
					</MuiGrid>
				</MuiGrid>

			</React.Fragment>
		)
	}
}

export default ElectiveTeachersAndTAsComponent
